import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import classNames from "classnames";
import lotusIcon from "images/icons/lotus.svg";
import lotusDark from "images/icons/lotus-dark-bold.svg";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { EmailSubscribe } from "./EmailSubscribe";
import { scrollToElement } from "./scrollToElement";

const useStyles = makeStyles((theme) => ({
    errorMessage: {
        marginTop: theme.spacing(0),
    },
    inner: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        textAlign: "center",

        maxWidth: "50%",
        margin: theme.spacing(0, "auto"),
        [theme.breakpoints.down("md")]: {
            maxWidth: "100%",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    },
    root: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.grey800,
    },
    dark: {
        backgroundColor: theme.palette.primary200,
        color: theme.palette.grey700,
    },
    description: {
        paddingBottom: theme.spacing(2),
    },
    section: {
        paddingBottom: theme.spacing(1),

        "&:last-child": {
            paddingBottom: 0,
        },
    },
}));

export const Newsletter = (props: {
    dark?: boolean; // NOTE: currently, the newsletter breaks when not in dark mode, so fix that first if you want to use this on a light background
}) => {
    const classes = useStyles();
    const { dark } = props;
    const location = useLocation();
    const newsletterId = "newsletter";

    useEffect(() => {
        if (location.hash?.slice(1) === newsletterId) {
            const element = document.getElementById(newsletterId);
            if (element) {
                scrollToElement(element, { offset: 10 });
            }
        }
    }, [location]);

    return (
        <Box className={classNames(classes.root, { [classes.dark]: dark })} id={newsletterId}>
            <Box className={classes.inner}>
                <Box className={classes.section}>
                    <img src={lotusDark} alt="lotus icon" />
                </Box>
                <Box className={classes.section}>
                    <Typography variant="h2">Receive our newsletter</Typography>
                </Box>
                <Box className={classes.section}>
                    <Typography variant="body1" className={classes.description}>
                        Enjoy mindfulness teachings distilled into practical tips, tools, and
                        meditations for everyday life.
                    </Typography>
                </Box>
                <Box className={classes.section}>
                    <EmailSubscribe
                        dark={dark}
                        emailListId="give-mindful-influence-newsletter"
                        placement="footer"
                    />
                </Box>
            </Box>
        </Box>
    );
};
